export default "__VITE_ASSET__CWT09__z__"